






























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import ButtonBehaviour from "@/form/ButtonBehaviour.vue";
import FontAwesomeIcon from "@/components/FontAwesomeIcon.vue";
@Component({
	components: {
		ButtonBehaviour,
		FontAwesomeIcon,
	},
})
export default class FileFormatActionsRenderer<RowType> extends Vue {
	/**
	 * rowIndex is the index of the record
	 */
	@Prop(Number) rowIndex!: number;

	/**
	 * row id is the employer file format item id
	 */
	@Prop(Number) fileFormatId!: number;

	@Prop(String) rowFileFormatName!: string;
	@Prop(Boolean) deletable!: boolean;

	private onClickDelete(event: MouseEvent): void {
		event.stopPropagation();

		this.$emit("clickDelete", {
			rowIndex: this.rowIndex,
			fileFormatId: this.fileFormatId,
		});
	}
}
